import type { ApiClient } from '@carbonwebmail/api-client'
import type { DashboardDto } from '@carbonwebmail/contracts'
import { useCallback } from 'react'
import type { AsyncState } from '../../ui/Async.js'
import { useLoaded } from '../../ui/useLoaded.js'

/**
 * The sending-health numbers, and the three states fetching them can be in.
 *
 * `failed` is a state of its own rather than zeroes, because zeroes on this
 * screen are a claim: nothing queued, nothing unknown, nothing dead. Showing
 * that when the request failed tells someone their sending is idle when it may
 * be on fire.
 */

export type DashboardState = AsyncState<DashboardDto>

export function useDashboard({ client }: { readonly client: ApiClient }) {
  const load = useCallback(() => client.dashboard(), [client])
  const { state, reload } = useLoaded<DashboardDto>(
    load,
    'We could not load your sending health. Please try again in a moment.',
  )

  return { state, retry: reload }
}
